export const news = [
  {
    id: 22,
    date: "22.06.2026",
    content: "news.no22",
  },
  {
    id: 19,
    date: "10.06.2026",
    content: "news.no19",
  },
  {
    id: 28,
    date: "18.05.2026",
    content: "news.no28",
  },
  {
    id: 21,
    date: "13.05.2026",
    content: "news.no21",
  },
  {
    id: 20,
    date: "12.05.2026",
    content: "news.no20",
  },
  {
    id: 17,
    date: "11.05.2026",
    content: "news.no17",
  },
  {
    id: 24,
    date: "23.04.2026",
    content: "news.no24",
  },
  {
    id: 18,
    date: "15.04.2026",
    content: "news.no18",
  },
  {
    id: 23,
    date: "06.03.2026",
    content: "news.no23",
  },
  {
    id: 16,
    date: "19.11.2025",
    content: "news.no16",
  },
  {
    id: 15,
    date: "17.11.2025",
    content: "news.no15",
  },
  {
    id: 27,
    date: "10.11.2025",
    content: "news.no27",
  },
  {
    id: 29,
    date: "28.05.2025",
    content: "news.no29",
  },
  {
    id: 26,
    date: "30.04.2025",
    content: "news.no26",
  },
  {
    id: 14,
    date: "30.04.2025",
    content: "news.no14",
  },
  {
    id: 13,
    date: "24.04.2025",
    content: "news.no13",
  },
  {
    id: 12,
    date: "13.03.2025",
    content: "news.no12",
  },
  {
    id: 11,
    date: "26.02.2025",
    content: "news.no11",
  },
  {
    id: 9,
    date: "03.02.2025",
    content: "news.no9",
  },
  {
    id: 10,
    date: "26.01.2025",
    content: "news.no10",
  },
  {
    id: 8,
    date: "30.12.2024",
    content: "news.no8",
  },
  {
    id: 7,
    date: "26.11.2024",
    title: "HAWKING",
    content: "news.no7",
  },
  {
    id: 6,
    date: "08.11.2024",
    title: "HAWKING",
    content: "news.no6",
  },
  {
    id: 5,
    date: "29.10.2024",
    title: "HAWKING",
    content: "news.no5",
  },
  {
    id: 4,
    date: "10.10.2024",
    title: "HAWKING",
    content: "news.no4",
  },
  {
    id: 1,
    date: "10.06.2024",
    title: "HAWKING",
    content: "news.no1",
    href: "https://www.ucg.ac.me/objava/blog/618282/objava/181449-span-class-cyrlatignore-hawking-span-projekat-predstavljen-na-sajmu-evropskih-projekata",
  },
  {
    id: 25,
    date: "04.06.2024",
    content: "news.no25",
  },
  {
    id: 2,
    date: "29.05.2024",
    title: "HAWKING",
    content: "news.no2",
    href: "https://www.ucg.ac.me/objava/blog/618282/objava/180943-onlajn-sastanak-projekta-hawking-virtuelna-saradnja-i-osiguranje-kvaliteta",
  },
  {
    id: 3,
    date: "29.02.2024",
    title: "HAWKING",
    content: "news.no3",
    href: "https://www.ucg.ac.me/objava/blog/618282/objava/180340-kick-off-za-projekat-hawking-poboljsanje-pristupa-visokom-obrazovanju-za-osobe-s-invaliditetom",
  },
];
